import { type SettingsState } from '../../../types';
// eslint-disable-next-line import/no-cycle
import { globalState, updateState } from '../../models';
import type { StateUpdateOptionsWithoutEventName } from '../../types';

export const setMobileLongFormToolbarId = async (
  id: NonNullable<SettingsState['mobileLongFormToolbar']>['id'],
  options: StateUpdateOptionsWithoutEventName,
) => {
  if (globalState.getState().persistent.settings.mobileLongFormToolbar?.id === id) {
    return;
  }

  return updateState(
    (state) => {
      state.persistent.settings.mobileLongFormToolbar = { id };
    },
    { ...options, eventName: 'mobile-long-from-toolbar-updated' },
  );
};

export const setMobileShortFormToolbarId = async (
  id: NonNullable<SettingsState['mobileShortFormToolbar']>['id'],
  options: StateUpdateOptionsWithoutEventName,
) => {
  if (globalState.getState().persistent.settings.mobileShortFormToolbar?.id === id) {
    return;
  }

  return updateState(
    (state) => {
      state.persistent.settings.mobileShortFormToolbar = { id };
    },
    { ...options, eventName: 'mobile-short-from-toolbar-updated' },
  );
};
